/* eslint-disable max-len */
export const defaultMessage = 'Acesse ou crie uma conta'
export const laboratoryMessage = 'Boas-vindas ao Nav Dasa, a plataforma de saúde {prefix} {laboratory}'
export const DEFAULT_TITLE_NEW_LOGIN = 'Acesse ou crie uma conta'
export const DEFAULT_MESSAGE_NEW_LOGIN =
    'Para iniciar um <strong>cadastro</strong> ou <strong>acessar</strong> o Nav Dasa, insira seu CPF. Caso seja menor de idade, preencha com o CPF do responsável:'
export const brandLayouts = {
    brandEmphasis: 'brandEmphasis',
    newLogin: 'newLogin',
    singleBrand: 'singleBrand',
}
export const WARNING_SERVICE_IS_DOWN = {
    title: 'Ops, serviço fora do ar',
    message: 'Detectamos instabilidades no nosso sistema e estamos trabalhando para resolver isso o mais breve possível.',
    featureMessage: 'Aguarde alguns minutos e tente novamente.',
}
